import React from 'react'

const Grid = ({ children }) => <div className="grid">{children}</div>

export default Grid
